export default __webpack_public_path__ + "static/media/coffee-cup-1.4bd12194.png";